module.exports = "https://trybtryb-legacy.web.app/img/rounded-desktop.f4cf0028.svg";